import script from "./OfNavbarLeft.vue?vue&type=script&setup=true&lang=js"
export * from "./OfNavbarLeft.vue?vue&type=script&setup=true&lang=js"

import "./OfNavbarLeft.vue?vue&type=style&index=0&id=57118680&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57118680"]])

export default __exports__